<template>
  <NewBsBox :bs="{ 'cmp.overlayers.option': 'wrapper', ...bs }">
    <slot name="head" />
    <EmptyText
      v-if="error"
      :bs="{ p: 16, }"
    >
      <div> 加载出错: {{ error }} </div>
      <BeerIcon
        :size="14"
        :bs="{ ml: 8, cursor: 'pointer' }"
        :grid-size="36"
        :icon-path="RETRY_PATH"
        color="danger"
        @click.stop="exec"
      />
    </EmptyText>
    <EmptyText
      v-else-if="loading"
    >
      <LoadingSpinner :size="18" />
      <NewBsBox :bs="{ ml: 8, color: 'brand' }">
        加载中...
      </NewBsBox>
    </EmptyText>
    <EmptyText v-else-if="misMatch">
      <div
        v-if="allowCustom"
        style="text-align: center;"
      >
        无匹配选项
        <BeerButton
          :bs="{ display: 'flex', mr: 0 }"
          variant="text"
          icon-right="setting"
          @click.stop="() => addOption(filterText)"
        >
          新建「{{ filterText }}」
        </BeerButton>
      </div>
      <template v-else>
        <slot name="empty">
          <div
            style="text-align: center;"
          >
            无匹配 「{{ filterText }}」 选项
            <br>
            修改关键字试试
          </div>
        </slot>
      </template>
    </EmptyText>
    <EmptyText v-else-if="empty">
      无选项数据
    </EmptyText>
    <template v-else>
      <slot />
      <NewBsBox
        v-if="$slots.action"
        :bs="actionBs"
      >
        <!--
          @slot 选项框底部显示的 slot，一般显示action
        -->
        <slot name="action" />
      </NewBsBox>
    </template>
  </NewBsBox>
</template>

<script lang="ts">
  import {
    computed, defineComponent, PropType,
  } from 'vue'
  import WithBsBox from '@xhs/yam-beer/cmp/primitive/WithBsBox'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import LoadingSpinner from '@xhs/yam-beer/cmp/common/Spinner/LoadingSpinner.vue'
  import BeerButton from '@xhs/yam-beer/cmp/common/Button/Button.vue'
  import {
    RETRY_PATH,
  } from '@xhs/yam-beer/cmp/constants/builtinIcon'
  import BeerIcon from '@xhs/yam-beer/cmp/common/Icon/Icon.vue'
  import { InputMode } from '../../../compose/options/useOptions'
  import { StatusHook } from '../../../compose/status'
  import { BeerStyleObj } from '../../../core'

  const ACTIONLBAR_HEIGHT = 46

  const EmptyText = WithBsBox({
    bs: {
      color: 'mute',
      minHeight: 160,
      fontSize: '14px',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  })

  export default defineComponent({
    name: 'SelectBox',
    components: {
      NewBsBox,
      LoadingSpinner,
      EmptyText,
      BeerButton,
      BeerIcon,
    },
    props: {
      allowCustom: {
        type: Boolean,
        default: false,
      },
      inputMode: {
        type: String as PropType<InputMode>,
        default: 'select',
      },
      addOption: {
        type: Function as PropType<((filterText: string) => void)>,
        required: false,
      },
      filterText: {
        type: String,
      },
      status: {
        type: Object as PropType<StatusHook<string>>,
        required: true,
      },
      empty: {
        type: Boolean,
        default: false,
      },
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },
    setup(props) {
      const misMatch = computed(() => {
        if (!props.filterText) {
          return false
        }
        if (props.inputMode === 'filter') {
          return props.empty
        }
        if (props.inputMode === 'search') {
          return !props.status.loading.value && !props.status.error.value && props.empty
        }
        return false
      })
      return {
        RETRY_PATH,
        misMatch,
        error: props.status.error,
        loading: props.status.loading,
        exec: props.status.exec,
        actionBs: {
          position: 'sticky',
          bottom: -8,
          bg: 'white',
          display: 'flex',
          cursor: 'unset',
          height: ACTIONLBAR_HEIGHT,
          mb: -8,
          alignItems: 'center',
          justifyContent: 'flex-end',
        },
      }
    },
  })
</script>
